import "./default-button.component.scss";
import { FC, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import sortImage from "../assets/images/sortImage.svg";
import filter from "../assets/images/filter.svg";
import plus from "../assets/images/plus.svg";
import back from "../assets/images/back.svg";
import { styled, alpha } from "@mui/material/styles";
import {
  Button,
  Chip,
  InputBase,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { DefaultButton } from "./default-button.component";
import { useNavigate } from "react-router-dom";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import useConstant from "use-constant";
import { useAsync } from "react-async-hook";
import InputTextField from "./text-field.component";

interface PageHeadingProps {
  title: string;
  // subTitle?: string;
  hasBackButton?: boolean;
  hasFilter?: boolean;
  addNew?: () => void;
  onSearch?: (value: string) => void;
}

export const PageHeading: FC<PageHeadingProps> = (props) => {
  const [sortToggle, setSortToggle] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [searchInput, setSearchInput] = useState<string>(String());

  const navigate = useNavigate();

  // Generic reusable hook
  const useDebouncedSearch = (searchFunction: any) => {
    // Handle the input text state
    const [inputText, setInputText] = useState("");

    // Debounce the original search async function
    const debouncedSearchFunction = useConstant(() =>
      AwesomeDebouncePromise(searchFunction, 500)
    );

    // The async callback is run each time the text changes,
    // but as the search function is debounced, it does not
    // fire a new request on each keystroke
    const searchResults = useAsync(async () => {
      debouncedSearchFunction(inputText);
    }, [debouncedSearchFunction, inputText]);

    // Return everything needed for the hook consumer
    return {
      inputText,
      setInputText,
      searchResults,
    };
  };

  const useSearchStarwarsHero = () =>
    useDebouncedSearch((inputText: any) => {
      props.onSearch && props.onSearch(inputText);
    });
  const { inputText, setInputText, searchResults } = useSearchStarwarsHero();

  const sortDropdown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setSortToggle(true);
  };

  const handleClose = () => {
    setSortToggle(false);
  };

  const onSearch = (e: any) => {
    setInputText(e.target.value);
  };

  return (
    <div className="page-heading-component d-flex justify-content-between">
      <div className="d-flex justify-content-between title-div">
        {props.hasBackButton ? (
          <div>
            <DefaultButton onClick={() => navigate(-1)} className="back-button">
              <img src={back} alt="Back Button" />
            </DefaultButton>
          </div>
        ) : (
          <></>
        )}
        <div className="page-header">
          <h2 className="page-heading-text">{props.title}</h2>
          {/* <span className="page-sub-title">{props.subTitle}</span> */}
        </div>
      </div>
      <div className="d-flex justify-content-between">
        {props.hasFilter ? (
          <>
            <div className="d-flex align-center p-relative page-heading-search">
              <SearchIcon
                className="page-heading-search-icon"
                color="inherit"
              />
              <InputTextField
                className="page-heading-search-input"
                value={inputText ?? ""}
                autoComplete="off"
                // label="Invoice No"
                placeholder="Search..."
                InputLabelProps={{ style: { fontFamily: "GilroyBold" } }}
                onChange={(e) => onSearch(e)}
              />
            </div>
            <div>
              <Button className="header-button1" onClick={sortDropdown}>
                <img src={sortImage} />
              </Button>
              <Menu
                className="sortListBox"
                id="basic-menu"
                anchorEl={anchorEl}
                open={sortToggle}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem className="sortDropDown" onClick={handleClose}>
                  Eatimate: Start To End
                </MenuItem>
                <MenuItem className="sortDropDown" onClick={handleClose}>
                  Eatimate: End To Start
                </MenuItem>
                <MenuItem className="sortDropDown" onClick={handleClose}>
                  Amount: High To Low
                </MenuItem>
                <MenuItem className="sortDropDown" onClick={handleClose}>
                  Amount: Low To High
                </MenuItem>
              </Menu>
            </div>

            <Button className="header-button2">
              <img src={filter} />
            </Button>

            <Button className="header-button3" onClick={props.addNew}>
              <img src={plus} />
            </Button>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
